<template>
  <div class="mr-r20">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h3 mr-r15">트랩 목록</div>
    </el-row>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <el-button class="mr-r4" size="mini" type="secondary" @click="addMibTrap">불러오기</el-button>
        <div class="setting-addel mr-r15">
          <el-button size="mini" @click="addTrap"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="deleteTrap" :disabled="checkedRow.length === 0"><i class="fas fa-minus"></i></el-button>
        </div>
        <span class="mr-r4">수집여부</span>
        <div class="setting-addel">
          <el-button size="mini" @click="onCollectAll(true)"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" @click="onCollectAll(false)"><i class="far fa-square"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box" align="right">
        <el-button class="mr-r4" size="mini" type="primary" @click="onSaveButton" :disabled="!checkDifferenceTrapDataFlag">저장</el-button>
        <el-button class="mr-r4" size="mini" :disabled="!checkDifferenceTrapDataFlag" @click="onCancelButton">취소</el-button>
        <w-header-search-button @click="toggleSearchTool"/>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper :column-default="columnDefault" ref="trapTable" :data="trapDatas" :columns="columns" highlight-current-row :show-custom-header="true" :show-search-tool="showSearchTool"
      @row-click="onRowClick"
      @selection-change="onSelectionChange">
        <template slot-scope="scope" slot="apply-flag-slot">
          <el-switch v-model="scope.row.applyFlag" active-value="Y" inactive-value="N" @change="changeDifferenceDataFlag"/>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-add-trap-popup title="트랩 추가" ref="addTrapPopup" :trap-datas="trapDatas" @insert-snmptrap="loadData" />
    <w-add-mib-trap-popup ref="addMibTrapPopup" :trap-origin-datas="trapDatas" @reload-trap="loadData"/>
  </div>
</template>

<script>
import { isEmpty, isEqual, cloneDeep, differenceWith, isNil, every } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtils from '@/utils/message';
import integratedTrapSettingAPI from '@/api/settings/log/integrated-trap-settings';
import WAddTrapPopup from '../popup/AddTrapPopup';
import WAddMibTrapPopup from '../popup/AddMibTrapPopup';

export default {
  name: 'WTrapListTable',
  components: {
    WAddTrapPopup,
    WAddMibTrapPopup,
  },
  props: {
    activeTab: String,
  },
  data() {
    const columns = [
      {
        type: 'selection',
        width: '50',
      },
      {
        prop: 'applyFlag',
        label: '수집',
        align: 'center',
        width: '60',
        scopedSlot: 'apply-flag-slot',
      },
      {
        prop: 'snmptrapName',
        label: '정책명',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'snmptrapVersion',
        label: '버전',
        width: '70px',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'snmptrapOid',
        label: 'OID',
        width: '200px',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'snmptrapGenericName',
        label: 'Generic',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'snmptrapSpecificId',
        label: 'Specific',
        searchable: true,
        sortable: true,
        formatter: this.getSpecificIdFormatter,
      },
    ];
    return {
      showSearchTool: false,
      columns,
      trapDatas: [],
      trapOriginDatas: [],
      selectedRow: null,
      checkedRow: [],
      checkDifferenceTrapDataFlag: false,
      columnDefault,
      collectAll: false,
    };
  },
  watch: {
    activeTab(value) {
      if (!isNil(value) && value === 'WTrapCollectSetting') {
        this.loadData();
      }
    },
  },
  mounted() {
    if (this.activeTab === 'WTrapCollectSetting') {
      this.loadData();
    }
  },
  methods: {
    /**
     * trap 데이터를 불러오고 Default Select Row를 설정한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      integratedTrapSettingAPI.getSnmptrapSetDetail().then((response) => {
        this.trapDatas = cloneDeep(response.data.data);
        this.trapOriginDatas = cloneDeep(response.data.data);
        this.onRowClick(this.trapDatas[0]);
        this.$nextTick(() => {
          this.$refs.trapTable.$children[0].setCurrentRow(this.trapDatas[0]);
        });
        this.changeDifferenceDataFlag();
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '트랩 목록', false));
        throw new Error(e);
      });
    },
    getStringFormatter(row, column, value) {
      return isEmpty(value) ? EMPTY_TEXT : value;
    },
    getSpecificIdFormatter(row, column, value) {
      return isNil(value) || value === -1 ? EMPTY_TEXT : value;
    },
    /**
     * trap 테이블의 row가 선택되면 트랩 정보 상세보기에 데이터를 전송해 띄운다.
     * @author Minyeong
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowClick(row) {
      this.selectedRow = row;
      this.$emit('show-trap-detail', row);
    },
    /**
     * 트랩 추가 팝업을 띄운다.
     * @author Minyeong
     */
    addTrap() {
      this.$refs.addTrapPopup.$refs.slidingPopup.open();
    },
    /**
     * 선택된 트랩들을 삭제한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    deleteTrap() {
      const confirmMsg = msgUtils.getBasicConfirmData('트랩을 삭제');
      this.$confirm(confirmMsg[0], confirmMsg[1], confirmMsg[2]).then(() => {
        integratedTrapSettingAPI.deleteSnmptrap(this.checkedRow).then((response) => {
          if (response.data.success) {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '트랩', response.data.success));
            this.selectedRow = null;
            this.loadData();
          } else {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '트랩', response.data.success));
          }
        }).catch((e) => {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '트랩', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    addMibTrap() {
      this.$refs.addMibTrapPopup.open();
    },
    onSelectionChange(selection) {
      this.checkedRow = selection;
    },
    changeDifferenceDataFlag() {
      this.changeCollectAll();
      this.checkDifferenceTrapDataFlag = !isEqual(this.trapDatas, this.trapOriginDatas);
    },
    onCollectAll(value) {
      if (value) {
        // true : 전체 선택
        this.trapDatas.forEach((item) => {
          item.applyFlag = 'Y';
        });
      } else {
        // false : 전체 선택 해제
        this.trapDatas.forEach((item) => {
          item.applyFlag = 'N';
        });
      }
      this.changeDifferenceDataFlag();
    },
    changeCollectAll() {
      if (isEmpty(this.trapDatas)) {
        this.collectAll = false;
        return;
      }
      if (every(this.trapDatas, { applyFlag: 'Y' })) {
        this.collectAll = true;
      } else {
        this.collectAll = false;
      }
    },
    /**
     * 저장 버튼을 누르면 변경사항이 있는 트랩 데이터들을 수정한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveButton() {
      const params = differenceWith(this.trapDatas, this.trapOriginDatas, isEqual);
      integratedTrapSettingAPI.updateSnmptrap(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
          this.selectedRow = null;
          this.loadData();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', false));
        throw new Error(e);
      });
    },
    onCancelButton() {
      this.trapDatas = cloneDeep(this.trapOriginDatas);
      this.changeDifferenceDataFlag();
    },
    toggleSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/SnmpTrap/components/TrapListTable.vue